/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Slots_Display_DayInputs */

const en_time_slots_display_day = /** @type {(inputs: Time_Slots_Display_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointments on`)
};

const de_time_slots_display_day = /** @type {(inputs: Time_Slots_Display_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine am`)
};

/**
* | output |
* | --- |
* | "Appointments on" |
*
* @param {Time_Slots_Display_DayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_slots_display_day = /** @type {((inputs?: Time_Slots_Display_DayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Slots_Display_DayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_slots_display_day(inputs)
	return en_time_slots_display_day(inputs)
});